export default function(update) {
  return new Array(update.length);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/sparse.js
// module id = 889
// module chunks = 3